module.exports = __webpack_public_path__ + "img/shipin.62dd318a.png";